import * as React from 'react'
import { IDevice } from '../../../interfaces/types.ts'

import { ChangeTrackerAssignment } from '../ChangeTrackerAssignment/ChangeTrackerAssignment.tsx'
import { sendCommand } from '../../../helpers/commandHelper.ts'
import dataStore from '../../../store/dataStore.ts'
import toast from 'react-hot-toast'

interface Props {
    iconOnly?: boolean
    tracker: IDevice
    short?: boolean
    unassign?: boolean
}

export const TrackerAssignmentButton: React.FC<Props> = (props) => {
    const {tracker, } = props
    const [open, setOpen] = React.useState(false)
    const devices = dataStore(s => s.devices)
    const pets = dataStore(s => s.pets)

    const devicesWithPets: IDevice[] = devices.filter(d => !!d.petId)
    const canMove = pets.length !== devicesWithPets.length

    const doUnAssign = async () => {
        const resultData = await sendCommand('un-assign', tracker.iccid, undefined)
        if (resultData) {
            dataStore.getState().setDevices(resultData)
            toast.success('Tracker un-assigned')
        } else {
            toast.error('Error, Gibi Tracker un-assignment failed, try again later.')
        }
    }

    const button = /*iconOnly ? (
            <div id={'uab'} className={'text-secondary text-xl'} onClick={() => setOpen(true)}>
                <FontAwesomeIcon icon={faCircleMinus}/>
            </div>
        ) :*/
        tracker?.petId ? <button className={`btn btn-secondary btn-xs btn-ghost text-secondary without-ring h-fit`}
                                 disabled={!tracker?.petId}
                                 onClick={doUnAssign}>
            Un-assign
        </button> : <button className={`btn btn-secondary btn-xs btn-ghost text-secondary without-ring h-fit`}
                            onClick={() => setOpen(true)}
                            disabled={!canMove}>
            Assign
        </button>

    return (
        <div>
            {button}
            {!tracker?.petId ? <ChangeTrackerAssignment tracker={tracker} open={open} setOpen={setOpen}/> : null}
        </div>
    )

    // const buttonText = tracker?.petId ? short ? '' : '' :
    //     short ? 'Assign' : 'Assign to a Pet'
    //
    // const iconButton = (
    //     <div className={'text-secondary text-xl'} onClick={() => setOpen(true)}>
    //         <FontAwesomeIcon icon={faShuffle}/>
    //     </div>
    // )
    //
    // const button = iconOnly ? iconButton : buttonText ?
    //     <button className={`btn btn-secondary btn-xs btn-ghost text-secondary without-ring h-fit`}
    //             onClick={() => setOpen(true)}
    //             disabled={!canMove}
    //     >
    //         {buttonText}
    //     </button> : null
    //
    // return unAssignButton || button ? (
    //     <div>
    //         {unassign ? unAssignButton : button}
    //         <ChangeTrackerAssignment tracker={tracker} open={open} setOpen={setOpen}/>
    //     </div>
    // ) : null
}
